<template>
    <div class="toast-container" v-if="hasToasts">
      <div v-for="(item, index) in toasts" v-bind:key="index" class="centix-toast" v-bind:class="{'success' : item.messageType === 'success', 'error' : item.messageType === 'error', 'info' : item.messageType === 'info' }"  v-on:click="removeToast(item)">
        
        <div v-if="!item.component" class="container-fluid px-0">
          <div class="row">
            <div class="col-10">
              <h3 v-if="item.title.length > 0">{{ item.title }} </h3>
              <p v-html="item.message"></p>
            </div>
            <div class="col-2 text-right">
              <span class="close-button" v-on:click="removeToast(item)">X</span>
            </div>
          </div>
        </div>

        <component v-else-if="item.component" :is="item.component" v-bind="item.bind" @remove-toast="removeToast(item)" />

      </div>
    </div>
</template>

<script>
import 'vue';
import lodashDelay from 'lodash/delay';

export default {
  name: 'Toaster',
  data: function () {
    return {
      toasts: []
    };
  },
  computed: {
    hasToasts () {
      return this.toasts.length > 0;
    }
  },
  methods: {
    showSuccess: function (msg, title = '', duration = 3000) {
      let self = this;
      let toast = {
        id: self.getRandomID(),
        message: msg,
        title: title,
        messageType: 'success'
      };
      self.toasts.push(toast);

      lodashDelay(() => self.removeToast(toast), duration);
    },
    showError: function (msg, title = '', duration = 3000) {
      let self = this;
      let toast = {
        id: self.getRandomID(),
        message: msg,
        title: title,
        messageType: 'error'
      };
      self.toasts.push(toast);

      lodashDelay(() => self.removeToast(toast), duration);
    },
    showInfo: function (msg, title = '', duration = 3000) {
      let self = this;
      let toast = {
        id: self.getRandomID(),
        message: msg,
        title: title,
        messageType: 'info'
      };
      self.toasts.push(toast);

      lodashDelay(() => self.removeToast(toast), duration);
    },
    showComponent: function (data, duration = 3000) {
      let self = this;
      let toast = {
        id: self.getRandomID(),
        component: data.component,
        bind: data.bind,
        messageType: 'info'
      };
      self.toasts.push(toast);

      lodashDelay(() => self.removeToast(toast), duration);
    },
    removeToast: function (toast) {
      let self = this;
      self.toasts = self.toasts.filter(x => x.id !== toast.id);
    },
    getRandomID () {
      return Math.random().toString(36).substring(7);
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';

@keyframes example {
    from {opacity: 0.0; right: -200px;}
    to {opacity: 1.0; right: 0;}
}

.toast-container {
  position: absolute;
  top: 90px;
  right: 20px;
  z-index: 9999;
  overflow: hidden;
  .centix-toast {
    position: relative;
    display: block;
    margin-bottom: 20px;
    border-radius: 4px;
    color: $sub200;
    padding: 12px;
    animation-name: example;
    animation-duration: 0.4s;
    background: white;
    width: 300px;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
    border-left: 8px solid white;
    &.success {
      border-color: rgba(40, 153, 40, 1);
    }
    &.error {
      border-color: rgba(241, 57, 57, 1);
    }
    &.info {
      border-color: #1e88e5;
    }
    .close-button {
      vertical-align: middle;
      height: 100%;
      padding: 12px;
      color: $sub200;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
</style>
